import React, { useState } from 'react';
import { Link } from '@inertiajs/react';
import SalesLayout from '../../../components/SalesLayout.jsx';

function formatPrice(cents) {
  if (cents == null) return '—';
  return `$${(cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
}

export default function SalesDealsShow({ deal }) {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(deal.share_url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const savings = (deal.list_subtotal_cents || 0) - (deal.price_cents || 0);

  return (
    <SalesLayout>
      <div className="max-w-2xl mx-auto p-6 sm:p-8 space-y-6">
        <div>
          <Link href="/sales" className="text-sm font-medium text-indigo-600 hover:text-indigo-700">
            ← My deals
          </Link>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900">{deal.name}</h1>
          <p className="mt-1 text-sm text-gray-500">
            {deal.plan === 'subscription' ? 'Subscription' : 'One-time'} · {deal.facility_type_label}
          </p>
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm space-y-4">
          <h2 className="text-lg font-semibold text-gray-900">Share link</h2>
          {deal.redeemable ? (
            <>
              <div className="flex gap-2">
                <input
                  readOnly
                  value={deal.share_url}
                  className="flex-1 min-w-0 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm font-mono text-gray-700"
                />
                <button
                  type="button"
                  onClick={copyLink}
                  className="shrink-0 rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-700 cursor-pointer transition"
                >
                  {copied ? 'Copied' : 'Copy'}
                </button>
              </div>
              <p className="text-xs text-gray-500">
                Single use — the link stops working the moment someone completes checkout.
              </p>
            </>
          ) : (
            <p className="text-sm text-gray-600">
              {deal.status === 'redeemed' && `Redeemed${deal.redeemed_at ? ` on ${deal.redeemed_at}` : ''}.`}
              {deal.status === 'voided' && 'This deal was withdrawn by an administrator.'}
              {deal.status === 'active' && deal.expired && 'This deal has expired. Ask an admin, or create a new one.'}
            </p>
          )}
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm space-y-3">
          <h2 className="text-lg font-semibold text-gray-900">What's included</h2>
          <ul className="space-y-1.5">
            {(deal.items || []).map((item) => (
              <li key={item.name} className="flex justify-between text-sm">
                <span className="text-gray-700">{item.name}</span>
                <span className="text-gray-500">×{item.quantity}</span>
              </li>
            ))}
          </ul>
          <div className="pt-3 border-t border-gray-100 space-y-1 text-sm">
            <div className="flex justify-between text-gray-500">
              <span>Standard price</span>
              <span>{formatPrice(deal.list_subtotal_cents)}</span>
            </div>
            <div className="flex justify-between font-semibold text-gray-900">
              <span>Customer pays</span>
              <span>{formatPrice(deal.price_cents)}</span>
            </div>
            {savings > 0 && (
              <div className="flex justify-between text-green-700">
                <span>Discount</span>
                <span>{formatPrice(savings)}</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </SalesLayout>
  );
}
